<template>
	<div id="posterset" class="page">
		<div class="poster-box">
			<img class="bg" v-bind:src="posterdir"/>
		</div>
		<div class="btn">
			请长按海报保存
		</div>
	</div>
</template>

<script>
import { Toast } from 'we-vue'
export default {
  data () {
    return {
		posterdir:''
	}
  },
  mounted () {
	
  },
  created(){
	this.posterdir = this.$route.query.posterdir
  },
  methods:{
	event_save(){
		
	}
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	#posterset{
		background-color:#FFFFFF;
		min-height:100vh;
	}
	.poster-box{
		padding:3vw;
		position:relative;
	}
	.poster-box .bg{
		width:100%;
	}
	.poster-box .qcode{
		position:absolute;
		width:22vw;
		right:12vw;
		bottom:23vw;
	}
	.poster-box input{
		text-indent:5px;
		height:5vw;
		color:#ffffff;
		height:10vw;
	}
	.poster-box > input{
		position:absolute;
		left:11vw;
		height:10vw;
		border:0px;
		bottom:35vw;
		width:50vw;
		background-color:rgba(254, 41, 41, 0.57);
	}
	.poster-box .phone{
		width:50vw;
		position:absolute;
		bottom:23vw;
		left:11vw;
		line-height:10vw;
		color:#FFFFFF;
	}
	.poster-box .phone input{
		width:35vw;
		position:static;
		display:inline-block;
		border:0px;
		float:right;
		background-color:rgba(254, 41, 41, 0.57);
	}
	.poster-box .school{
		width:50vw;
		position:absolute;
		bottom:35vw;
	}
	.poster-box .school{
		width:70vw;
		position:absolute;
		bottom:11vw;
		left:11vw;
		line-height:10vw;
		color:#FFFFFF;
	}
	.poster-box .school input{
		width:55vw;
		position:static;
		display:inline-block;
		border:0px;
		float:right;
		background-color:rgba(254, 41, 41, 0.57);
	}
	.btn{
		height: 12vw;
		display: block;
		margin: 0vw 3vw;
		text-align: center;
		color: #FFFFFF;
		background: -webkit-gradient(linear, left top, right top, from(#fa8d60), to(#e76025));
		background: linear-gradient(to right, #fa8d60, #e76025);
		font-size: 4vw;
		line-height: 12vw;
		border-radius: 10px;
		margin-bottom:3vw;
	}
</style>


// WEBPACK FOOTER //
// src/components/Posterdown.vue